import React from "react";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

interface IProps {
  roomSchameScale: number;
  setRoomSchameScale: (value: number) => void;
}

const RoomSchemeScale: React.FC<IProps> = ({ roomSchameScale, setRoomSchameScale }) => {
  const handleChangeScale = (newScale: number) => {
    if (newScale <= 0.05) {
      setRoomSchameScale(0.05);
    } else {
      setRoomSchameScale(newScale);
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Button variant="outlined" onClick={() => handleChangeScale(roomSchameScale - 0.05)}>
          -
        </Button>
        <Typography variant="button" style={{ padding: "0 5px" }}>
          Skala: {((roomSchameScale / 1) * 100).toFixed(0)}%
        </Typography>
        <Button variant="outlined" onClick={() => handleChangeScale(roomSchameScale + 0.05)}>
          +
        </Button>
      </Grid>
    </Grid>
  );
};

export default RoomSchemeScale;
